import { FormattedMessage } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { Dialog } from '@flipster/react/design-system/dialog';
import webviewHandler from '@flipster/utils/webview-handler';

interface KycDialogProps {
  isOpen: boolean;
  close: () => void;
  onExit?: () => void;
}
export const KycDialog = ({ isOpen, close, onExit }: KycDialogProps) => {
  const router = useRouter();
  return (
    <Dialog.Root isOpen={isOpen} onExit={onExit}>
      <Dialog.Title label={<FormattedMessage id='Assets.r250401.Identity_verification' />} />
      <Dialog.Content>
        <FormattedMessage id='Assets.r250401.Identity_verification_required_description' />
      </Dialog.Content>
      <Dialog.Footer>
        <Dialog.Button
          hierarchy='secondary'
          color='neutral'
          label={<FormattedMessage id='Common.r250401.Close' />}
          onClick={close}
        />
        <Dialog.Button
          label={<FormattedMessage id='Assets.r250401.Verify_now' />}
          onClick={() => {
            webviewHandler.postMessage({ action: 'link', params: { page: 'user/kyc' } }, () =>
              router.push('/user/kyc'),
            );
            close();
          }}
        />
      </Dialog.Footer>
    </Dialog.Root>
  );
};
